import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BytesPipe } from './bytes/bytes.pipe';
import { CnpjPipe } from './cnpj.pipe';
import { CpfPipe } from './cpf.pipe';
import { DataComHoraPipe } from './data-com-hora.pipe';
import { DataSimplesPipe } from './data-simples.pipe';
import { FormatTimePipeHHMM } from './format-time-hhmm.pipe';
import { FormatTimePipe } from './format-time.pipe';
import { HighlightPipe } from './highlight.pipe';
import { OrderByPipe } from './order-by.pipe';
import { SimNaoPipe } from './sim-nao.pipe';
import { TipoArquivoMetadadoPipe } from './tipo-arquivo-metadado.pipe';
import { TipoEscolaPipe } from './tipo-escola.pipe';



@NgModule({
  declarations: [DataSimplesPipe, 
                 FormatTimePipe, 
                 FormatTimePipeHHMM,
                 CnpjPipe, 
                 CpfPipe, 
                 HighlightPipe, 
                 DataComHoraPipe,  
                 OrderByPipe,
                 SimNaoPipe,
                 BytesPipe,
                 TipoEscolaPipe,
                 TipoArquivoMetadadoPipe],
  imports: [
    CommonModule
  ],
  exports:[DataSimplesPipe,
           FormatTimePipe, 
           FormatTimePipeHHMM,
           OrderByPipe , 
           CnpjPipe, 
           HighlightPipe,
           DataComHoraPipe, 
           CpfPipe,
           SimNaoPipe,
           BytesPipe,
           TipoEscolaPipe,
           TipoArquivoMetadadoPipe]
})
export class SharedPipesModule { }
